export * from "@workspace/gamja-platform/lib/ga";
